import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { getProfile } from "../../webServices/Apis";
import Loader from "../Loader/Loader";
import { message } from "antd";

const Invoice = () => {


  const location = useLocation();
  const { invoice } = location.state || {};
  const [profile, setProfile] = useState('')
  const [loading, setLoading] = useState(false)

  console.log("invv", invoice)

  useEffect(() => {
    contractorProfile();
  }, []);

  const contractorProfile = async () => {
    try {
      setLoading(true)
      const response = await getProfile();
      if (response?.data?.success) {
        setProfile(response?.data?.data)
        
      }
    } catch (error) {
      console.log("Error while fetching profile", error)
      message.error(error?.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }


  const tableStyle = {
    fontFamily: "'Arial', sans-serif",
    fontSize: "16px",
    color: "#555",
    maxWidth: "800px",
    width: "100%",
    lineHeight: "24px",
    textAlign: "left",
    margin: "40px auto",
    border: "1px solid #eee",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)",
  };

  const tbodyStyle = {
    paddingTop: "10px",
    position: "relative",
    zIndex: 1,
  };

  const headerCellStyle = {
    padding: "5px",
    verticalAlign: "top",
    background: "#9f9f9f",
    borderBottom: "1px solid #ddd",
    fontWeight: "bold",
    color: "white",
    border: "1px solid #919191",
  };

  const cellStyle = {
    padding: "5px",
    verticalAlign: "top",
    color: "black",
    border: "1px solid #919191",
  };

  const totalCellStyle = {
    borderBottom: "2px solid #9f9f9f",
    borderLeft: "2px solid #9f9f9f",
    borderRight: "2px solid #919191",
    padding: "10px",
    textAlign: "right",
    color: "black",
  };

  function formatDate(dateString) {
    const date = new Date(dateString); // Parse the date string
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, '0'); // Get day
    const year = date.getFullYear(); // Get year

    return `${month}-${day}-${year}`; // Return formatted date as MM-DD-YYYY
  }



  return (
    <>

      <div
        className="flex justify-center items-center h-screen w-screen fixed top-0 left-0"
        style={{ backgroundColor: "#f5f5f5" }}
      >
        {loading && (
          <Loader />
        )}
        <table style={tableStyle}>
          <tbody style={tbodyStyle}>
            {invoice && profile ? (
              <>
                <tr className="top">
                  <td colSpan="4" style={{ background: "#eaeaea", padding: "0 0 0 10px" }}>
                    <table style={{ width: "100%", textAlign: "left" }}>
                      <tr>
                        <td style={{ paddingBottom: "25px" }}>
                          <h3 style={{ margin: "5px 0" }}>Date</h3>
                          {formatDate(invoice?.projectInvoice?.createdAt)}
                        </td>
                        <td
                          style={{
                            textAlign: "left",
                            background: "#9f9f9f",
                            color: "white",
                            paddingLeft: "10px",
                            paddingBottom: "25px",
                            width: "47%",
                          }}
                        >
                          <h3 style={{ margin: "5px 0" }}>Invoice#</h3>
                          {invoice?.projectInvoice?.id}

                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" style={{ padding: "15px 10px", paddingBottom: "40px", color: "black" }}>
                    <h3 style={{ margin: "5px 0" }}>Pay to</h3>
                    {console.log("conanay", invoice)}
                    {invoice?.projectInvoice?.subContractorName} {invoice?.lastname}
                    <br />
                    {invoice?.subContractorCompany}
                    <br />
                    {(invoice?.street || invoice?.city || invoice?.code) && (
                      <>
                      {invoice?.street}, {invoice?.city}, {invoice?.code} <br/> {invoice?.prov}
                      </>
                    )}     

                    <br />
                    {invoice?.hst && (
                      <>
                       HST #: {invoice?.hst}
                       </>
                    )}
                   
                  </td>
                  <td style={{ padding: "15px 10px", paddingBottom: "40px", color: "black", width: "43%" }}>
                    <h3 style={{ margin: "5px 0" }}>Bill To</h3>
                    {profile?.companyName}
                    <br />
                    {profile?.address}
                  </td>
                </tr>
                <tr>
                  <td style={headerCellStyle}>Description</td>
                  <td style={{ ...headerCellStyle, borderLeft: "none", borderRight: "none" }}></td>
                  <td style={{ ...headerCellStyle, borderLeft: "none", borderRight: "none" }}></td>
                  <td style={{ ...headerCellStyle, textAlign: "right" }}>Amount</td>
                </tr>
                <tr>
                  <td colSpan="4" style={{ ...cellStyle, textAlign: "left" }}>
                    Assigned Project : {invoice?.projectInvoice?.assignProjectName}
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" style={{ ...cellStyle, background: "#eaeaea" }}>From: {formatDate(invoice?.projectInvoice?.startDate)} - To: {formatDate(invoice?.projectInvoice?.endDate)}</td>
                  {/* <td colSpan="4" style={{ ...cellStyle, background: "#eaeaea" }}>End: {invoice?.projectInvoice?.endDate}</td> */}
                </tr>
                {invoice?.projectTasks?.map((task) => (
                <tr>
                    <td colSpan="1" style={{ ...cellStyle, background: "#eaeaea" }}> Project Id : {task?.projectNumber} - {task?.projectName}</td>        
                    <td colSpan="2" style={{ ...cellStyle, background: "#eaeaea" }}> Task : {task?.taskName}</td>
                  <td colSpan="3" style={{ ...cellStyle, textAlign: "right", background: "#eaeaea" }}> ${task?.taskBudget}</td>
                  
                  
                </tr>
                 ))}
                {/* <tr>
                  <td style={cellStyle}>Granite</td>
                  <td style={cellStyle}>n/a</td>
                  <td style={cellStyle}>n/a</td>
                  <td style={{ ...cellStyle, textAlign: "right" }}>192.00</td>
                </tr> */}
                
                <tr>
                  <td colSpan="3"></td>
                  <td style={totalCellStyle}>
                    <b>Sub Total :</b> <span>${invoice?.projectInvoice?.workingHours}</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td style={totalCellStyle}>
                    <b>HST ({invoice?.hstRate ?? 0} %) :</b> <span>$ {invoice?.hstAmount ?? 0}</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td style={{ ...totalCellStyle, fontSize: "20px" }}>
                    <b>Total :</b> <span>${(Number(invoice.projectInvoice.workingHours) +
                      Number(invoice.hstAmount)).toFixed(2)}</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" style={{ textAlign: "right", fontSize: "18px", color: "#000" }}>
                    <p>
                      I understand and have signed the Declaration of Insurance electronic form for this
                      invoice.
                    </p>
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  No invoices found to print
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

    </>
  );
};

export default Invoice;
